import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconProjectListReport.tsx
const IconProjectListReport = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "#998e8e",
			d: "M11 6h6v2h-6zm-1 9h5v2h-5z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#998e8e",
			d: "M7 3h2.586v1H19v7h2V3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1M9 5H7v6h2z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#998e8e",
			d: "M9.586 3H7v2h2V4h.586z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#998e8e",
			fillRule: "evenodd",
			d: "M10 15h5v2h-5z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#998e8e",
			fillRule: "evenodd",
			d: "M2.293 20.707A1 1 0 0 0 3 21h16.22a1 1 0 0 0 .97-.757L22.5 11H17v-1h-6v1H5.5L4 16.998V5h3V3H3a1 1 0 0 0-1 1v16a1 1 0 0 0 .293.707M18 13h1.938l-1.5 6H5.562l1.5-6H18",
			clipRule: "evenodd"
		})
	]
});
var IconProjectListReport_default = forwardRef(IconProjectListReport);
//#endregion
export { IconProjectListReport_default as default };
